// debounce notify the same desc and message error
import { debounce } from 'lodash-es';
import { notification } from 'antd';

const debounceMap: Record<string, typeof notification.error> = {};
export const notifyErrorDebounce = ({
  description,
  message,
}: {
  description: string;
  message: string;
}) => {
  const key = `${description}${message}`;
  if (!debounceMap[key]) {
    debounceMap[key] = debounce(notification.error, 4000, { leading: true });
  }
  debounceMap[key]({ description, message });
};

export const notifyWarnDebounce = ({
  description,
  message,
}: {
  description: string;
  message: string;
}) => {
  const key = `${description}${message}`;
  if (!debounceMap[key]) {
    debounceMap[key] = debounce(notification.warning, 300, { leading: true });
  }
  debounceMap[key]({ description, message });
};
